import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import { ClaimService as ExportClaimService } from 'gw-capability-claim';
import { GatewayDocumentService } from 'gw-capability-gateway-document';

import { Icon, withModalContext, Loader } from '@jutro/components';
import {
    TranslatorContext,
    withIntl
} from '@jutro/locale';
import { DataTable, DisplayColumn } from '@jutro/legacy/datatable';
import { ServiceManager } from '@jutro/legacy/services';
import moment from 'moment';

import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withDependencies } from '@xengage/gw-portals-dependency-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { DatatableUtil } from '@xengage/gw-portals-util-js';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { LoaderExt } from 'gw-components-platform-react';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import Analytics from "../../../../capabilities/cpmi-capability-analytics/services/Analytics"
import ContactUtil from '../../utils/ClaimsDetailsUtil';
import ContactLinkComponent from '../../components/ContactLinkComponent/ContactLinkComponent';
import VendorLinkComponent from '../../components/VendorLinkComponent/VendorLinkComponent';
import metadata from './CPMIClaimDetails.metadata.json5';
import CreateNotePopUp from './CreateNotePopUp';
import CPMIMontanaClaimDetails from './CPMIMontanaClaimDetails';
import claimDetailsStyles from './ClaimDetails.module.scss';
import messages from '../../Claims.messages';
import './ClaimDetails.messages';

import { Link as DownloadLink } from '@jutro/router';

class ClaimDetails extends Component {
    static propTypes = {
        location: PropTypes.shape({
            state: PropTypes.shape({
                summarystate: PropTypes.shape({}).isRequired
            }).isRequired
        }).isRequired,
        match: PropTypes.shape({
            url: PropTypes.string,
            params: PropTypes.shape({
                claimNumber: PropTypes.string
            })
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
            goBack: PropTypes.func,
            location: PropTypes.shape({
                state: PropTypes.shape({})
            })
        }).isRequired,
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string
        }).isRequired,
        ClaimService: PropTypes.shape({
            addRecentlyViewedClaim: PropTypes.func,
            claimsDocUploadToken: PropTypes.func,
            claimsRemoveDocument: PropTypes.func,
            createClaimNote: PropTypes.func,
            getClaimDetail: PropTypes.func,
            getClaimNotes: PropTypes.func,
            uploadDocument: PropTypes.func
        }).isRequired,
        ClaimDownloadService: PropTypes.shape({
            getClaimDocument: PropTypes.func
        }).isRequired,
        intl: PropTypes.func.isRequired
    };

    static contextType = TranslatorContext;

    localeService = ServiceManager.getService('locale-service');

    

    constructor(props) {
        super(props);
        this.getDocumentRemove = this.getDocumentRemove.bind(this);
        // this?.props?.location?.state?.lobName = "sdsdsd"
    }

    state = {
        claimDetailsData: '',
        isClaimDetailsPageVisible: true,
        isLoading: true,
        isLoadingSub: false,
        coverage: 0,
        redirectPath: {},
        uploadToken: null,
        documentAlert: '',
        selectedTab: 'summaryTab',
        downloadButtonflag:true,
        requestClaimStatusFlag: false,
        claimReportStatus: false,
        claimsAssociationArray:[]
    };

    componentDidMount = () => {
        const {authHeader}=this.props;
        const userID = this.props.userInfo.email;
        const {
            history: { location: state = {} }
        } = this.props;
        const redirectPathValues = state;
        this.setState({
            redirectPath: _.get(redirectPathValues, 'state.redirectPath') || '/claims'
        });
        this.getClaimDetailsResponse();
        

        // this.setState({
        //    isLoading:true,
        //     claimReportStatus:this.getClaimReportStatus(),
        // });
        // this.claimsDocUploadToken();
        Analytics.trackActivity([{
            applicationName: 'PE',activityType: 'pageview',userID: userID,title: 'Claim Details',page: '/claims/ClaimNumber'}],authHeader)
    };

    getFormattedNotesArray = (res) => {
        return res.map((note) => {
            return {
                author: `${note.author.firstName} ${note.author.lastName}`,
                date: note.dateCreated,
                subject: note.subject,
                note: note.body
            };
        });
    }

    getClaimReportStatus = (claimDetails) => {

        if(!_.isEmpty(claimDetails))
        {
            const userID = this.props.userInfo.email;
            const {authHeader} = this.props;
    
            const allClaimStatus = [
                {
                    accountNumber: claimDetails.policy.accountNumber,
                    policyNumber: claimDetails.policy.policyNumber,
                    reportType: 'ClaimStatusReport',
                    claimNumber:claimDetails.claimNumber,
                    emailID: userID,
                },
            ];
            
            GatewayClaimService.reportStatus(allClaimStatus,authHeader).then((res)=>{
                
                this.setState({
                    
                    claimReportStatus:res,
                });
               
    
            }).finally(()=>{
                this.setState({
                    isLoading:false,
                    
                });
            })
        }
       
        
    }

    getClaimDetailsResponse = () => {
        const { ClaimService, authHeader, match } = this.props;
        Promise.all([GatewayClaimService.getClaimDetailSecure_Ext(match.params.claimNumber, authHeader),
            GatewayClaimService.getClaimNotes(match.params.claimNumber, authHeader)]).then(
            (response) => {
                const [claimDetails, notesResponse] = response;
               
                const notesArray = this.getFormattedNotesArray(notesResponse);
                const translator = this.context;
                const pa = claimDetails.lobs.personalAuto;
                if (pa && pa.vehicleIncidents[0]) {
                    pa.vehicleIncidents[0].selected = true;
                }

                const responseData = {
                    claim: claimDetails,
                    notes: notesArray,
                    claimPayments: claimDetails.checks,
                    claimServices: claimDetails.serviceRequests,
                    activities: claimDetails.activities || {},
                    reporter: this.getReportedByName(claimDetails, translator),
                    claimLosslocation: claimDetails.lossLocation,
                    selectedVehicleIncident:
                        pa && pa.vehicleIncidents[0] ? pa.vehicleIncidents[0] : {},
                    vehicles: this.getInvolvedVehicles(claimDetails),
                    claimContactsVendors: claimDetails.vendors,
                    claimHospitalsDays: claimDetails.hospitalDays,
                    claimContactsWithoutAgent: this.getPolicyTable(claimDetails),
                    lobName :this?.props?.location?.state?.lobName
                };

                const reportStatus = this.getClaimReportStatus(claimDetails)
                
                const tempclaimsAssociationArray = [];
                // eslint-disable-next-line array-callback-return
                responseData?.claim?.claimAssociations?.map((loopItem)=>{
                    if(loopItem.claimAssocTypeName === "Primary/umbrella"){
                        tempclaimsAssociationArray.push(loopItem);
                    }
                    
                })
                // eslint-disable-next-line react/no-unused-state
                this.setState({claimsAssociationArray:tempclaimsAssociationArray});

                this.setState({
                    claimDetailsData: responseData,
                    isLoading: false,
                // claimReportStatus:reportStatus
                });
            }
        ).catch(() => {
            const { modalContext, history } = this.props;
            this.setState({ isLoading: false });
            return modalContext.showAlert({
                title:"Unable to fetch claim information",
                message: "Please contact us at 1-800-231-1363 so that we can assist.",
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).then(()=>{
                history.goBack();
            }).catch(_.noop);
            
        });

        if (_.isFunction(ClaimService.addRecentlyViewedClaim)) {
            ClaimService.addRecentlyViewedClaim(match.params.claimNumber, authHeader);
        }
    };

    getCell = (item, index, { id: property }) => {
        return item[property];
    };

    getExposureValue = (item, index, { id: property }) => {
        const translator = this.context;
        // return item[property];
        return translator({
            id: `typekey.ExposureType.${item[property]}`,
            defaultMessage: `typekey.ExposureType.${item[property]}`
        })
    };
    

    getExposureCoverage = (item, index, { id: property }) => {
        const translator = this.context;
        // return item[property];
        return translator({ 
            id: `typekey.CoverageType.${item[property]}`,
            defaultMessage: `typekey.CoverageType.${item[property]}`
        })
    };

   

    getStatusValueCell = (item, index, { id: property }) => {
        return item[property]==="open"?"Open":"Closed";
    };

    getDataTableCell = (item, index, { path: property }) => {
        return item[property];
    };

    getNotesColumnCellDate=(item,index,property)=>{
        const currentDate =new Date(item.date) ;
        const Time=currentDate.toLocaleString('en-US', { hour: 'numeric',minute: 'numeric', hour12: true });
        const DateCreated=moment(currentDate).format('MM/DD/YYYY');
        return `${DateCreated}  ${Time}`   
    }

    getNotesColumnCell = (item, index, { path: property }) => {
        const translator = this.context;
        let toolTipMessage = '';
        switch (property) {
            case 'author':
                toolTipMessage = translator(messages.notesAuthor);
                break;
            case 'date':
                toolTipMessage = translator(messages.notesDate);
                break;
            case 'subject':
                toolTipMessage = translator(messages.notesSubject);
                break;
            case 'note':
                toolTipMessage = translator(messages.notesContent);
                break;
            default:
                toolTipMessage = '';
        }
        return (
            <div
                style={{ whiteSpace: 'normal' }}
                className={claimDetailsStyles.gwClaimDetailsNotesWrapper}
            >
                <span title={toolTipMessage}>{item[property]}</span>
            </div>
        );
    };

    isContactTypeCheck = (contact, contactType) => {
        return ContactUtil.isInstanceOf(contact, contactType);
    };

    getContactTypePersonVisible = (item) => {
        return (this.isContactTypeCheck(item, 'Person') && !this.isContactTypeCheck(item, 'PersonVendor'));
    };

    getContactTypeVendorVisible = (item) => {
        return (this.isContactTypeCheck(item, 'CompanyVendor') || this.isContactTypeCheck(item, 'PersonVendor'));
    };

    getPartyNameLink = (item) => {
        const contactDTO = _.get(item, 'contactdetails');
        if (this.getContactTypeVendorVisible(item)) {
            const contact = { contactDTO };
            return <div className="partyNameClasss"><VendorLinkComponent id="vendorCell" vendors={[contact]} /></div>;
        }
        return <div className="partyNameClasss"><ContactLinkComponent id="contactCell" contactDetails={contactDTO} /></div>;
    };

    getRoleInvolvement = (claimContact) => {
        let roles = [];
        if (
            claimContact
            && claimContact.contactRolesDisplay
            && claimContact.contactRolesDisplay.length > 0
        ) {
            roles = claimContact.contactRolesDisplay;
        }
        return _.join(roles, ', ');
    };


    getPolicyTable = (claimDetailsData) => {
        // if(claimDetailsData.length > 0){
        //     this.setState({downloadButtonflag:true})
        // }
        const claimContactsWithoutAgent =
        //  _.filter(  
        //     claimDetailsData.claimContacts,
        //     (claimContact) => {
        //         return claimContact.contactRoles.indexOf('agent') === -1;
        //     }
        // )
        claimDetailsData.claimContacts.map((claimContact) => {
            const roleInvolvement = this.getRoleInvolvement(claimContact);
            return {
                partyname: claimContact.contactDTO.displayName,
                involvement: roleInvolvement,
                primaryaddress: claimContact.contactDTO.primaryAddress,
                contactdetails: claimContact.contactDTO
            };
        });
        return claimContactsWithoutAgent;
    };
    

    getVehicleDetailsTable = (vehicles) => {
        return vehicles.map((vehicle) => {
            return {
                make: vehicle.make,
                model: vehicle.model,
                year: vehicle.year,
                license: vehicle.license,
                coverages: vehicle.coverages
            };
        });
    };

    getFormatCurrency = (deductible) => {
        let formattedAmount = '';
        if (deductible) {
            const { amount, currency } = deductible;
            if (amount && currency) {
                const locale = this.localeService.getPreferredLocale();
                formattedAmount = amount.toLocaleString(locale, {
                    style: 'currency',
                    currency,
                    currencyDisplay: 'code',
                });
            }
        }
        return formattedAmount;
    };

    getLimitType = (coverage, translator) => {
        if (coverage.incidentLimit && coverage.exposureLimit) {
            return (
                <div>
                    <p>{translator(messages.perAccident)}</p>
                    <p>{translator(messages.perPerson)}</p>
                </div>
            );
        }
        if (coverage.incidentLimit) {
            return translator(messages.perAccident);
        }
        if (coverage.exposureLimit) {
            return translator(messages.perPerson);
        }
        return '-';
    };

    handleError = (title, message) => {
        const { modalContext } = this.props;
        return modalContext.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    // handleError = (title, message) => {
    //     const { modalContext } = this.props;
    //     return modalContext.showAlert({
    //         title: title,
    //         message: message,
    //         status: 'error',
    //         icon: 'mi-error-outline',
    //         confirmButtonText: commonMessages.ok
    //     }).catch(_.noop);
    // };
    

    getLimitValue = (coverage) => {
        if (coverage.incidentLimit && coverage.exposureLimit) {
            return (
                <div>
                    <p>{this.getFormatCurrency(coverage.incidentLimit)}</p>
                    <p>{this.getFormatCurrency(coverage.exposureLimit)}</p>
                </div>
            );
        }
        if (coverage.incidentLimit) {
            return this.getFormatCurrency(coverage.incidentLimit);
        }
        if (coverage.exposureLimit) {
            return this.getFormatCurrency(coverage.exposureLimit);
        }
        return '-';
    };

   

    getLinkExposureAdjuster = (item) => {
        const translator = this.context;
        return this.getAdjusterNameExposure(item, translator)
    };

    getVehicleCoverageTable = (coverages, translator) => {
        return coverages.map((coverage) => {
            const limitValue = this.getLimitValue(coverage);
            const limitType = this.getLimitType(coverage, translator);
            const deductibleAmount = coverage.deductible
                ? this.getFormatCurrency(coverage.deductible)
                : '';
            return {
                type: coverage.name,
                deductible: deductibleAmount,
                limittype: limitType,
                limitvalue: limitValue
            };
        });
    };

    getBackToPreviousState = () => {
        const { history } = this.props;
        const redirectpath = {
            pathname: '/claims',
           
        };
        history.push(redirectpath);
    };

    getClaimNumber = (claimDetailsData, translator) => {
        return translator(messages.claimDetailNumber,
            { num: claimDetailsData.claimNumber });
    };

    getPolicyNumber = (claimDetailsData) => {
        const redirectPath = `/policies/${claimDetailsData.policy.policyNumber}/summary`;
        if (appConfig.persona === 'policyholder') {
            return claimDetailsData.policy.policyNumber;
        }
        return (
            <Link to={redirectPath} className={claimDetailsStyles.gwClaimDetailsLink}>
                {claimDetailsData.policy.policyNumber}
            </Link>
        );
    };

    getAccountNumber = (claimDetailsData) => {
        const redirectPath = `/accounts/${claimDetailsData.policy.accountNumber}/summary`;
        if (appConfig.persona === 'policyholder') {
            return claimDetailsData.policy.accountNumber;
        }
        return (
            <Link to={redirectPath} className={claimDetailsStyles.gwClaimDetailsLink}>
                {claimDetailsData.policy.accountNumber}
            </Link>
        );
    };

    getLossDate = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData.lossDate), { year: 'numeric', month: 'short', day: 'numeric' });
    }

    getEffectiveDateFun = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData), { year: 'numeric', month: 'short', day: 'numeric' });
    }

    getReportDateFun = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData), { year: 'numeric', month: 'short', day: 'numeric' });
    }


    getExipirationDate = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData), { year: 'numeric', month: 'short', day: 'numeric' });
    }
    

    getReportedByName = (claimDetailsData, translator) => {
        // if (claimDetailsData.claimReporter.reportedBy.displayName) {
        //     return claimDetailsData.claimReporter.reportedBy.displayName;
        // }
        if (claimDetailsData.claimReporter.reportedBy) {
            return claimDetailsData.claimReporter.reportedBy;
        }
        return translator(messages.unknown);
    };

    getPrimaryContactName = (claimDetailsData) => {
        if (claimDetailsData.mainContact && claimDetailsData.mainContact.displayName) {
            return claimDetailsData.mainContact.displayName;
        }
        return '';
    };

    getAdjusterName = (claimDetailsData, translator) => {
        if (claimDetailsData.adjuster.displayName) {
            const email = !_.isEmpty(claimDetailsData.adjuster.email)?claimDetailsData.adjuster.email:""
            return <a className="adjusterEmail" style={{color:"#26a9e0",textDecoration:"none"}} href={`mailto:${email}`}>{claimDetailsData.adjuster.displayName}</a>;
        }
        return translator(messages.unknown);
    };

    getAdjusterNameExposure = (adjObj, translator) => {
        if (adjObj.adjuster) {            
            const email = !_.isEmpty(adjObj.adjusterEmail)?adjObj.adjusterEmail:"" 
            return <a className="adjusterEmail" style={{color:"#26a9e0",textDecoration:"none"}} href={`mailto:${email}`}>{adjObj.adjuster}</a>;
        }
        return translator(messages.unknown);
    };

    toggleVehicleDetailsContainer = (claimDetailsData) => {
        if (
            claimDetailsData?.claim?.policy?.policyType_Ext === 'PersonalAuto'
            && claimDetailsData.vehicles.length > 0
        ) {
            return true;
        }
        return false;
    };

    getCoverageForSelectedVehicle = (claimDetailsData, translator) => {
        const { coverage } = this.state;
        const selectedVehicle = this.getInvolvedVehicles(claimDetailsData);
        if (!_.isEmpty(selectedVehicle)) {
            return translator(
                messages.coveragesFor,
                {
                    vehicleMake: selectedVehicle[coverage].make,
                    vehicleModel: selectedVehicle[coverage].model
                }
            );
        }
        return '';
    };

    getLossLocation = (claimDetailsData) => {
        let location = '';
        if (claimDetailsData.lossLocation && claimDetailsData.lossLocation.displayName) {
            location = claimDetailsData.lossLocation.displayName;
            location.replace('\n', ', ');
        }
        return location;
    };

    getLossLocationVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossLocation && claimDetailsData.lossLocation.displayName) {
            return true;
        }
        return false;
    };

    getEmployerNotifiedVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossType === 'WC') {
            return true;
        }
        return false;
    };

    getMMIDate = (claimDetailsData, intl) => {
        let mmiDate=' ';
        if (claimDetailsData.mmidate) {
            mmiDate= intl.formatDate(
                new Date(claimDetailsData.mmidate),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return mmiDate;
    };

    getClosedDate = (claimDetailsData, intl) => {
        let closedDate='  ';
        if (claimDetailsData.dateClosed) {
            closedDate= intl.formatDate(
                new Date(claimDetailsData.dateClosed),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return closedDate;
    };

    getReopenedDate = (claimDetailsData, intl) => {
        let reopenDate='  ';
        if (claimDetailsData.dateReOpened) {
            reopenDate= intl.formatDate(
                new Date(claimDetailsData.dateReOpened),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return reopenDate;
    };

    getEmployerNotifiedDate = (claimDetailsData, intl) => {
        let employernotifiedDate;
        if ((claimDetailsData.lossType === 'WC') && (claimDetailsData.lobs.workersComp.dateReportedToEmployer)) {
            employernotifiedDate = intl.formatDate(
                new Date(claimDetailsData.lobs.workersComp.dateReportedToEmployer),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return employernotifiedDate;
    };

    getHospitalDaysVisibility = (claimDetailsData) => {
        if (claimDetailsData.hospitalDays) {
            return true;
        }
        return false;
    };

    getInvolvedVehicles = (claimDetails) => {
        let involvedVehicles = [];
        const pa = claimDetails.lobs.personalAuto;
        const papolicy = claimDetails.policy.lobs.personalAuto;
        if (!pa) {
            return [];
        }
        if (
            pa.vehicleIncidents === null
            || pa.vehicleIncidents.length < 1
            || claimDetails.policy === null
            || papolicy.vehicles === null
        ) {
            return involvedVehicles;
        }

        const involvedVINarray = pa.vehicleIncidents.map((item) => {
            return item.vehicle.vIN;
        });
        involvedVehicles = _.filter(papolicy.vehicles, (vehicle) => {
            return involvedVINarray.indexOf(vehicle.vIN) !== -1;
        }).map((vehicle) => {
            return vehicle;
        });
        return involvedVehicles;
    };

    getSelectedVehicleCoverages = (claimDetails) => {
        const { coverage } = this.state;
        const selectedVehicle = this.getInvolvedVehicles(claimDetails);
        if (!_.isEmpty(selectedVehicle)) {
            return selectedVehicle[coverage].coverages;
        }
        return '';
    };

    showModal = () => {
        const translator = this.context;
        const { viewModelService } = this.props;
        const componentProps = {
            title: translator(messages.adjusterAddnoteButton),
            actionBtnLabel: translator(messages.createNoteSave),
            cancelBtnLabel: translator(messages.createNoteCancel),
            viewModelService: viewModelService
        };

        return ModalNextProvider.showModal(
            <CreateNotePopUp {...componentProps} />
        );
    }

    saveNoteData = (updatedNoteVMObj) => {
        const {
            match: {
                params: { claimNumber }
            },
            authHeader,
            ClaimService
        } = this.props;
        const { claimDetailsData } = this.state;
        GatewayClaimService.createClaimNote(
            claimNumber,
            updatedNoteVMObj.value,
            authHeader
        ).then((response) => {
            const newNote = this.getFormattedNotesArray([response]);
            claimDetailsData.notes = [...claimDetailsData.notes, ...newNote];
            return this.setState({
                selectedTab: 'notesTab',
                claimDetailsData: claimDetailsData
            });
        }).catch(() => {
            this.handleError(messages.createNoteErrorTitle, messages.createNoteErrorMessage);
        });
    };

    addNote = () => {
        this.showModal().then((updatedNoteVMObj) => {
            this.saveNoteData(updatedNoteVMObj);
        }).catch(_.noop);
    };

    getEmptyMessageVisibility = (notes) => {
        if (notes.length === 0) {
            return true;
        }
        return false;
    };

    getNotesTableVisibility = (notes) => {
        // this.setState({downloadButtonflag:false})
        if (notes.length > 0) {
            return true;
        }
        return false; 
    };

    getDataCell = (item, index, { path: property }) => {
        const translator = this.context;
        let toolTipMessage = '';
        switch (property) {
            case 'documentName':
                toolTipMessage = translator(messages.documentsName);
                break;
            case 'documentDate':
                toolTipMessage = translator(messages.documentsDateModified);
                break;
            default:
                toolTipMessage = '';
        }
        return (
            <span title={toolTipMessage}>
                {item[property]}
            </span>
        );
    };

     

    

    getViewandDownload = (item) => {
        const translator = this.context;
        
        const { ClaimDownloadService } = this.props;
        const { documentviewdownload: { docUID, sessionID } } = item;
        const claimDocumentLink = ClaimDownloadService
            .getClaimDocument(docUID, sessionID);
        return (
            <DownloadLink
                href={claimDocumentLink}
                target="_blank"
                key={item.documentviewdownload}
                className={claimDetailsStyles.documentIcon}
                title={translator(messages.documentsViewandDownload)}
                style={{display:'block'}}
            >
                <Icon icon="mi-insert_drive_file" />
            </DownloadLink>
        );
    };

    

    getDisplayCurrency=(deductible)=>{
        let displayCurrency='';
        if(deductible){
            const {amount,currency}=deductible;
            if(currency==='usd'){
                displayCurrency=amount.toLocaleString("en-US", {style:"currency", currency:'USD'});

            }
            
            
        }
        return displayCurrency
    };

    getVINMakeModel=(claimsdata)=>{
        
        // const varObject = [{"vin":"HGfdergjj0765","make":"sddfdf","model":"sdsdsd"},{"vin":"HGfdergjj0765","make":"sddfdf","model":"sdsdsd"},{"vin":"HGfdergjj0765","make":"sddfdf","model":"sdsdsd"}]
        
        return <DataTable
                    data={claimsdata?.policy?.lobs?.commercialAuto?.vehicles}
                    id=""
                    title={""}
                    titleId=""
                    titlePosition="left"
                    expandable={false}
                    showSearch={false}
                    showPagination={false}
                    isSorted={false}
                   
                >
                    <DisplayColumn
                        cell={(row) => <div style={{fontWeight:'bold',color:'#373737'}}>{row.vin + ', ' + row.make + ' ' + row.model}</div>}
                        columnProportion={1}
                        id=""
                        textAlign="left"
                        sortable={false}
                        header="VIN, Make Model"
                        headerClassName={claimDetailsStyles.vinHeadClass}
                       
            />
                </DataTable>
    };
    

    exportClaimDetail=()=>{
        const {authHeader,match } = this.props;

        if(match.params.claimNumber){
            const resultPromise = ExportClaimService.exportClaimDetail(match.params.claimNumber, authHeader)
                .then((res) => {
                    const base64 = res.base64;
                    const byteString = atob(base64);
    
                    // convert binary to array buff so we can construct a blob
                    const arrayBuffer = new ArrayBuffer(byteString.length);
                    const intArray = new Uint8Array(arrayBuffer);
    
                    for (let i = 0; i < byteString.length; i += 1) {
                        intArray[i] = byteString.charCodeAt(i);
                    }
                    const file = new Blob([intArray], { type: res.fileType});
                    // if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
                    //     window.navigator.msSaveBlob(file, `${res.fileName}.xlsx`);
                    // } else { // for other browsers
                    const fileURL = URL.createObjectURL(file);
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    a.href = fileURL;
                    a.download = `${res.fileName}`;
                    a.click();
                // }
                });
        }
    };

    getdateClosed=(claimDetailsData,intl)=>{
        if(claimDetailsData.claim.dateClosed){
            return intl.formatDate(new Date(claimDetailsData.claim.dateClosed), { year: 'numeric', month: 'short', day: 'numeric' })
        }
    };

    getDisplayDate=(string)=>{
        const date = new Date(string);
        return date.toLocaleDateString('en-US');
    };

    tabChangeFn =(id)=>{
        if(id === "summaryTab" || id === "notesTab" || id === "documentsTab"){
            this.setState({ downloadButtonflag: true });
        }else {
            this.setState({ downloadButtonflag: false });
        }
    }

    getDocumentRemove = (item) => {
        const translator = this.context;
        const { authHeader, ClaimService } = this.props;
        const { claimDetailsData } = this.state;
        const { Authorization } = authHeader;
        const { documentremove } = item;
        const {
            claimNumber, publicID, name, canDelete
        } = documentremove;
        this.setState({ documentAlert: '' });
        if (!canDelete) {
            const alertMsg = translator(messages.unableToDeleteClaims, { documentName: name });
            this.setState({ documentAlert: alertMsg });
            return;
        }
        ModalNextProvider.showConfirm({
            title: messages.confirmationToRemoveTitle,
            message: translator(messages.confirmationToRemoveMessage, { documentname: name }),
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.removeConfirmationYes,
            cancelButtonText: messages.removeConfirmationNo
        }).then(async (results) => {
            if (results === 'cancel') {
                return _.noop();
            }
            try {
                const isDeleteItem = await GatewayClaimService.claimsRemoveDocument(
                    [claimNumber, publicID],
                    { Authorization: Authorization }
                );
                if (isDeleteItem === false) {
                    return this.handleError(
                        messages.deletionFailedTitle,
                        messages.deletionFailedMessage
                    );
                }
                claimDetailsData.claim.documents = _.filter(
                    claimDetailsData.claim.documents,
                    (doc) => {
                        return doc.publicID !== publicID;
                    }
                );
                return this.setState({
                    claimDetailsData: claimDetailsData
                });
            } catch (e) {
                return this.handleError(
                    messages.removeServiceFailedTitle,
                    messages.removeServiceFailedMessage
                );
            }
        }, _.noop);
    };

    getRemoveIcon = (item) => {
        const translator = this.context;
        return (
            <Icon
                icon="mi-delete"
                onClick={() => this.getDocumentRemove(item)}
                className={claimDetailsStyles.documentIcon}
                title={translator(messages.documentsRemove)}
            />
        );
    };

    formatAMPM = (date) => {
        let hours = date.getHours() % 12;
        let minutes = date.getMinutes();
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        const strTime = `${hours}:${minutes} ${ampm}`;
        return strTime;
    };

    getDocumentsArray = (documents, intl) => {
        return documents.map((doc) => {
            const docDate = intl.formatDate(new Date(doc.dateModified), { year: 'numeric', month: 'short', day: 'numeric' });
            return {
                documentName: doc.name,
                
                documentDate: moment(doc.dateModified).format('MM/DD/YYYY'),//`${docDate} ${this.formatAMPM(new Date(doc.dateModified))}`,
                documentviewdownload: doc,
                documentremove: doc
            };
        });
    };

    getNotesArray = (notes, intl) => {
        return notes.map((noteData) => {
            const noteDate = intl.formatDate(new Date(noteData.date), { year: 'numeric', month: 'short', day: 'numeric' });
            return {
                author: noteData.author,
                date: `${noteDate} ${this.formatAMPM(new Date(noteData.date))}`,
                subject: noteData.subject,
                note: noteData.note
            };
        });
    };

    showServiceVendorAddress = (serviceData) => {
        const contactDTO = serviceData.vendor || serviceData;
        const vendor = { contactDTO };
        return <VendorLinkComponent id="vendorCell" vendors={[vendor]} />;
    };

    getVendorNameLink = (item) => {
        return <VendorLinkComponent id="vendorCell" vendors={[item]} />;
    };

    expanderContent = (data) => {
        const translator = this.context;
        const coverageArray = this.getVehicleCoverageTable(data.coverages, translator);
        const coveragesForVehicleHeader = translator(
            messages.coveragesFor,
            {
                vehicleMake: data.make,
                vehicleModel: data.model
            }
        );
        return (
            <>
                <h4>{coveragesForVehicleHeader}</h4>
                <DataTable
                    data={coverageArray}
                    id="vehicleCoverageTableId"
                    title={coveragesForVehicleHeader}
                    titleId="vehicleCoverageTitleId"
                    titlePosition="left"
                    expandable={false}
                    showSearch={false}
                    showPagination={false}
                >
                    <DisplayColumn
                        cell={(row) => row.type}
                        columnProportion={1}
                        header={translator(messages.type)}
                        id="typeHeader"
                        textAlign="left"
                        onSort={DatatableUtil.sortString}
                    />
                    <DisplayColumn
                        cell={(row) => row.deductible}
                        columnProportion={1}
                        header={translator(messages.deductible)}
                        id="deductibleHeader"
                        textAlign="left"
                        onSort={DatatableUtil.sortString}
                    />
                    <DisplayColumn
                        cell={(row) => row.limittype}
                        columnProportion={1}
                        header={translator(messages.limittype)}
                        id="limitTypeHead"
                        textAlign="left"
                        onSort={DatatableUtil.sortString}
                    />
                    <DisplayColumn
                        cell={(row) => row.limitvalue}
                        columnProportion={1}
                        header={translator(messages.limitvalue)}
                        id="limitValueHead"
                        textAlign="left"
                        onSort={DatatableUtil.sortNumber}
                    />
                </DataTable>
            </>
        );
    };

    formatPaymentDate = (claimPaymentDate, intl) => {
        return claimPaymentDate !== undefined ? intl.formatDate(
            new Date(claimPaymentDate), { year: 'numeric', month: 'short', day: 'numeric' }
        ) : ' ';
    }

    getPaymentGrossAmount = (paymentGrossAmount) => {
        let grossAmount;
        const { amount, currency } = paymentGrossAmount;
        const { intl } = this.props;
        if (amount && currency) {
            grossAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency: currency,
                    currencyDisplay: 'code'
                }
            );
        }
        return `${grossAmount}`;
    };

    getPaymentCheckNumber = (paymentCheckNumber) => {
        return paymentCheckNumber !== undefined ? paymentCheckNumber : ' ';
    };

    renderoadingStatus =()=>{
        // if (this.isLoadingSub) {
        //     return <div>hjsdsds</div>//<LoaderExt loaded={!isLoadingSub} />;
        // } else {
        //     return "ssdsdsd"
        // }
        return(<><div><LoaderExt loaded={true} customClass="claimDetailsLoader"/></div></>)
    }

    generatePaymentDetailsOverrides = (intl) => {
        const { claimDetailsData } = this.state;
        const translator = this.context;

        const paymentChecksPath = 'claimPayments';
        const paymentChecks = _.get(claimDetailsData, paymentChecksPath, []);
        const overrides = paymentChecks.map((paymentCheck, index) => {
            return {
                [`paymentScheduledDate${index}`]: {
                    value: this.formatPaymentDate(paymentCheck.scheduledDate, intl)
                },
                [`paymentIssueDate${index}`]: {
                    value: this.formatPaymentDate(paymentCheck.issueDate, intl)
                },
                [`paymentStatus${index}`]: {
                    value: translator({
                        id: `typekey.TransactionStatus.${paymentCheck.status}`,
                        defaultMessage: paymentCheck.status
                    })
                },
                [`paymentCheckNumber${index}`]: {
                    value: this.getPaymentCheckNumber(paymentCheck.checkNumber)
                },
                [`paymentPayee${index}`]: {
                    value: paymentCheck.payee.join(', ')
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    checkPaymentsHasDetails = () => {
        const { claimDetailsData } = this.state;
        return claimDetailsData.claim.checks && claimDetailsData.claim.checks.length > 0;
    };

    mapServiceStatus = (status) => {
        const translator = this.context;
        switch (status) {
            case 'workcomplete':
                return translator(messages.statusCompleted);
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return translator(messages.statusInProgress);
            case 'expired':
            case 'declined':
            case 'canceled':
                return translator(messages.statusOffTrack);
            default:
                return translator(messages.statusUnknown);
        }
    };

    changeStatusIcon = (status) => {
        switch (status) {
            case 'workcomplete':
                return 'check';
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return 'refresh';
            case 'expired':
            case 'declined':
            case 'canceled':
                return 'times';
            default:
                return ' ';
        }
    };

    showServiceCompletionDate = (serviceRequest) => {
        const translator = this.context;
        const checkServiceStatus = false;
        const serviceStatus = this.mapServiceStatus(serviceRequest.status);
        if (
            serviceStatus === translator(messages.statusInProgress)
            && serviceRequest.expectedServiceCompletionDate
        ) {
            return !checkServiceStatus;
        }
        return checkServiceStatus;
    };

    getServicePrimaryContact = (serviceRequest) => {
        const serviceContactRoles = `(${serviceRequest.customerClaimContact.contactRolesDisplay.join(
            ', '
        )})`;
        return (
            <>
                <ContactLinkComponent
                    contactDetails={serviceRequest.customerClaimContact.contactDTO}
                />
                <span>{serviceContactRoles}</span>
            </>
        );
    };

    generateServiceDetailsOverrides = (intl) => {
        const { claimDetailsData } = this.state;
        const serviceRequestsPath = 'claimServices';
        const serviceRequests = _.get(claimDetailsData, serviceRequestsPath, []);
        const overrides = serviceRequests.map((serviceRequest, index) => {
            return {
                [`serviceCompletionDate${index}`]: {
                    value: intl.formatDate(
                        new Date(serviceRequest.expectedServiceCompletionDate),
                        { year: 'numeric', month: 'short', day: 'numeric' }
                    ),
                    visible: this.showServiceCompletionDate(serviceRequest),
                },
                [`serviceStatusIcon${index}`]: {
                    icon: this.changeStatusIcon(serviceRequest.status)
                },
                [`serviceVendorLink${index}`]: {
                    value: this.showServiceVendorAddress(serviceRequest),
                },
                [`serviceStatus${index}`]: {
                    content: this.mapServiceStatus(serviceRequest.status)
                },
                [`servicePrimaryContact${index}`]: {
                    value: this.getServicePrimaryContact(serviceRequest),
                    visible:
                        appConfig.persona === 'producer'
                        || _.get(claimDetailsData, 'claim.policy.policyType', '') === 'WorkersComp'
                },
                [`serviceItems${index}`]: {
                    value: serviceRequest.services.join(', ')
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    checkServiceRequestsHasDetails = () => {
        const { claimDetailsData } = this.state;
        return (claimDetailsData.claim.serviceRequests
            && claimDetailsData.claim.serviceRequests.length > 0);
    };

    canAccessFinancials = () => {
        return appConfig.persona === 'producer' || appConfig.persona === 'csr';
    };

    claimsDocUploadToken = async () => {
        const { ClaimService, authHeader } = this.props;
        try {
            const sessionID = await GatewayClaimService.claimsDocUploadToken([], authHeader);
            this.setState({ uploadToken: sessionID });
        } catch (e) {
            this.handleError(
                commonMessages.errorUploadTitle,
                commonMessages.errorGenerateUploadToken
            );
        }
    };

    getPrimaryClaimNumbers = (item, index,{ id: property } ) => {

        // eslint-disable-next-line no-shadow
        
            const translator = this.context;

            const redirectpath = {
                pathname: `/claims/${item[property]}`,
                state: {
                    claimNumber: item[property],
                    redirectPath: '/claims',
                    claimStatus: item.status,
                    jurisdictionStateName:item.jurisdictionStateName,
                    claimStatusTBD:item.claimStatusTBD,
                    lobName:item.product
                }
            };
            // console.log(item)
            return (
                <Link to={redirectpath} target="_blank" style={{"width":"22%"}} className={claimDetailsStyles.gwClaimsLinkContent} title={translator(messages.claimNumber)}>
                    {item.claimStatusTBD !== "TBD" ? translator(item[property]) : "TBD"}
                </Link> 
            );        

    };

    getClaimNumbers = (item, index,property ) => {

        // eslint-disable-next-line no-shadow
        return item[property.id].map((loopitem,index)=>{
            const tempVar = item[property.id].length-1 !==index?',':''
            const translator = this.context;

            const redirectpath = {
                pathname: `/claims/${loopitem}`,
                state: {
                    claimNumber: loopitem,
                    redirectPath: '/claims',
                    claimStatus: item.status,
                    jurisdictionStateName:item.jurisdictionStateName,
                    claimStatusTBD:item.claimStatusTBD,
                    lobName:item.product
                }
            };
            // console.log(item)
            return (
                <Link to={redirectpath} target="_blank" style={{"width":"22%"}} className={claimDetailsStyles.gwClaimsLinkContent} title={translator(messages.claimNumber)}>
                    {item.claimStatusTBD !== "TBD" ? translator(loopitem + tempVar) : "TBD"}
                </Link> 
            );
           
           

        })
    };

    requestClaimStatusReport = () => {
        const { modalContext } = this.props;
        const translator = this.context;
        const userID = this.props.userInfo.email;
        const {authHeader} = this.props;
        const allClaimStatus = [
            {
                accountNumber: this.state.claimDetailsData.claim.policy.accountNumber,
                policyNumber: this.state.claimDetailsData.claim.policy.policyNumber,
                reportType: 'ClaimStatusReport',
                claimNumber:this.state.claimDetailsData.claim.claimNumber,
                emailID: userID,
            },
        ];

        modalContext.showConfirm({
            title: messages.ClaimStatusTitle,
            message: translator(messages.ClaimStatus, { email: userID }),
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.claimHistoryConfirm,
            cancelButtonText: messages.removeConfirmationNo
        }).then( (results) => {
            if (results === 'confirm') {
                try {
                    this.setState({
                        
                        claimReportStatus:false
                    });
                    const allClaimStatusReport =  GatewayClaimService.requestReport(
                        allClaimStatus,
                        authHeader
                    ).then((res) =>{
                    });
                } catch (documentDeletionError) {
                    modalContext.showAlert({
                        title: "error",
                        message: "An Error Occured",
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                }
                return true;
            }
        }, _.noop);
    }

    handleDocumentsUpload = async (file) => {
        const { modalContext } = this.props;
        const { authHeader, match, ClaimService } = this.props;
        const { claimDetailsData, uploadToken } = this.state;
        // const { ClaimService, authHeader } = this.props;
        const sessionID = await ClaimService.claimsDocUploadToken([], authHeader);
        // this.setState({ uploadToken: sessionID });
        const documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'fnol',
            securityType: 'unrestricted',
            status: 'approved',
            claimNumber: match.params.claimNumber,
            name: file.name,
            mimeType: file.type,
            sessionID: sessionID,
            author: "Policy Holder"
        };
        this.setState({ isLoadingSub: true });
        try {
            const documentsData = await GatewayClaimService.uploadDocument(
                file,
                documentMetaDataTemplate,
                authHeader
            );
            this.setState({ isLoadingSub: false });
            modalContext.showAlert({
                title: "Your document was successfully uploaded.",
                status: 'info',
                confirmButtonText: "OK",
            })
            claimDetailsData.claim.documents = [...claimDetailsData.claim.documents, documentsData];
            this.setState({ isLoadingSub: false });
            this.setState({
                claimDetailsData: claimDetailsData
            });
        } catch (e) {
            this.setState({ isLoadingSub: false });
            this.handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
        }
    };

    getPrimarybodypart = (claimDetailsData) => {
        let state = ' ';
        if (claimDetailsData.primaryBodyPart) {
            state = claimDetailsData.primaryBodyPart;
        }
        return state;
    };


    getJurisdiction = (claimDetailsData) => {
        // const statecode = claimDetailsData.lossLocation.state;
        // if(claimDetailsData.isUnifiedClaim){
        //     return claimDetailsData.jurisdictionState
        // }
        // const statecode = claimDetailsData.riskLocation.state;
        // const translator = this.context;
        // const { viewModelService } = this.props;
        // if (statecode !== undefined && statecode !== " ") {
        //     const typeList = viewModelService.create(
        //         {},
        //         "pc",
        //         "edge.capabilities.address.dto.AddressDTO"
        //     );
            
        //     const availableStates = typeList.state.aspects.availableValues;
            
        //     const statename = availableStates
        //         .filter((s) => {
                   
        //             return s.code === statecode;
        //         })
        //         .map((s) => {
                   
        //             return s.name;
        //         });
            
        //     const res = translator({
        //         id: statename[0],
        //         defaultMessage: statename[0],
        //     });
           
            
        //     return res;
        // }
        return  this?.props?.location?.state?.jurisdictionStateName;
    };
    

    getPolicyTypeData = (claimDetailsData) => {
        const translator = this.context;
        const policyTypeLabel = translator({
            id: `typekey.policyType.${claimDetailsData?.claim?.policy?.policyType_Ext}`,
            defaultMessage: claimDetailsData?.claim?.policy?.policyType_Ext
        })
        if(policyTypeLabel==='General Liablity Line 7' || policyTypeLabel==='General Liablity Line 7 '){
            return "General Liablity"
        } if(policyTypeLabel==='Commercial Auto Line 7 ' || policyTypeLabel==='Commercial Auto Line 7'){
            return "Commercial Auto"
        } if(policyTypeLabel==='Commercial Property Line 7 ' || policyTypeLabel==='Commercial Property Line 7'){
            return "Commercial Property"
        }

        return policyTypeLabel;
    }
   

    render() {
        const { intl } = this.props;
        const {
            claimDetailsData,
            isClaimDetailsPageVisible,
            isLoading,
            isLoadingSub,
            documentAlert,
            selectedTab
        } = this.state;
        const translator = this.context;
        if (isLoading) {
            return <LoaderExt loaded={!isLoading} />;
        }

        if (!claimDetailsData) {
            return null;
        }

        const policyArray = this.getPolicyTable(claimDetailsData.claim);
        let vehicleDetailsArray = [];
        let claimNotesArray = [];
        let documentsArray = [];
        const isWc7Montana = claimDetailsData?.claim?.jurisdictionState === 'Montana'
            && claimDetailsData?.claim?.policy?.policyType ==='WC7WorkersComp';

        if(claimDetailsData.claim.totalPayments.amount > 0){
            this.state.requestClaimStatusFlag = false;
        }else {
            this.state.requestClaimStatusFlag = true;
        }
        if (claimDetailsData.claim.documents.length > 0) {
            documentsArray = this.getDocumentsArray(claimDetailsData.claim.documents, intl);
        }
        if (this.toggleVehicleDetailsContainer(claimDetailsData)) {
            vehicleDetailsArray = this.getVehicleDetailsTable(claimDetailsData.vehicles);
        }
        if (claimDetailsData.notes.length > 0) {
            claimNotesArray = this.getNotesArray(claimDetailsData.notes, intl);
        }
        const overrides = {
            requestClaimStatusBtn: {
                visible: claimDetailsData?.claim?.claimType?.trim() !== 'Medical Only' && claimDetailsData?.claim?.policy?.policyType ==='WC7WorkersComp',
                disabled:!this.state.claimReportStatus,
            },
            partiesInvolvedTableGrid: {
                data: policyArray
            },
            vendorInvolvedTableGrid: {
                data: claimDetailsData.claimContactsVendors
            },
            vehicleDetailsDataTable: {
                data: vehicleDetailsArray,
                renderExpanderContent: this.expanderContent,
                visible: vehicleDetailsArray.length > 0
            },
            claimDetailsContainer: {
                visible: !isWc7Montana
            },
            cpmiMontanaClaimDetails:{
                visible: isWc7Montana,
                claimantName: claimDetailsData.claim.claimantName,
                insuredName: claimDetailsData.claim.primaryInsuredName,
                claimNumber: this?.props?.history?.location?.state?.claimStatusTBD === "TBD"?"TBD":claimDetailsData.claim.claimNumber,
                lossDate: this.getLossDate(claimDetailsData.claim, intl),
                claimStatus: claimDetailsData.claim.claimState?.toLowerCase() === "open" ? "Open" : "Closed",
                compensabilityStatus: claimDetailsData?.claim?.claimStatus,
                adjuster: this.getAdjusterName(claimDetailsData.claim, translator),
                adjusterPhoneNumber: claimDetailsData.claim.adjuster.phoneNumber,
                totalIncurred: this.getDisplayCurrency(claimDetailsData.claim.netToalIncurred)
            },
            notesTableGrid: {
                data: claimNotesArray,
                visible: this.getNotesTableVisibility(claimDetailsData.notes)
            },
            emptyDocsmsg: {
                visible: _.isEmpty(documentsArray)
            },
            claimStatus: {
                value: claimDetailsData.claim.claimState?.toLowerCase() === "open" ? "Open" : "Closed"
            },
            dateClosedId:{
                value:this.getClosedDate(claimDetailsData.claim, intl)
            },
            DateReopened:{
                value:this.getReopenedDate(claimDetailsData.claim,intl)
            },
            MMIid:{
                value: this.getMMIDate(claimDetailsData.claim, intl),
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            documentsTableGrid: {
                data: documentsArray,
                visible: documentsArray.length > 0
            },
            vendorTableContainer1:{
                visible:claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation"
            },
            vendorTableContainer:{
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            removeDocumentNotification: {
                message: documentAlert,
                visible: !_.isEmpty(documentAlert)
            },
            primaryContact: {
                visible: !!this.getPrimaryContactName(claimDetailsData.claim),
                value: this.getPrimaryContactName(claimDetailsData.claim)
            },
            emptyNotesMessage: {
                visible: this.getEmptyMessageVisibility(claimDetailsData.notes)
            },
            claimDetailNumber: {
                value:this?.props?.history?.location?.state?.claimStatusTBD === "TBD"?"TBD":claimDetailsData.claim.claimNumber
                // content: this.getClaimNumber(claimDetailsData.claim, translator)
            },
            policyNumber: {
                // value: this.getPolicyNumber(claimDetailsData.claim)
                value:claimDetailsData.claim.policy.policyNumber
            },
            accountNumber: {
                value:claimDetailsData.claim.policy.accountNumber
                // value: this.getAccountNumber(claimDetailsData.claim)
            },
            lossLocation: {
                visible: this.getLossLocationVisibility(claimDetailsData.claim),
                value: this.getLossLocation(claimDetailsData.claim)
            },
            employerNotified: {
                visible: this.getEmployerNotifiedVisibility(claimDetailsData.claim),
                // value: this.getEmployerNotifiedDate(claimDetailsData.claim, intl)
            },
            daysInHospital: {
                visible: this.getHospitalDaysVisibility(claimDetailsData.claim)
            },
            dateOfLoss: {
                value: this.getLossDate(claimDetailsData.claim, intl)
            },
            claimExpousuresTable:{
                data:claimDetailsData?.claim?.exposures
            },
            claimAssociationsTable:{
                data:this?.state?.claimsAssociationArray//claimDetailsData?.claim?.claimAssociations
            },
            claimAssociationsTableContainer:{
                visible:this?.state?.claimsAssociationArray.length > 0
            },
            claimAssociationsTab:{
                visible:this?.state?.claimsAssociationArray.length > 0
            },
            adjusterName: {
                value: this.getAdjusterName(claimDetailsData.claim, translator)
            },
            vehicleDetailsContainer: {
                visible:
                    ['producer', 'csr', 'policyholder'].includes(appConfig.persona)
                    && this.toggleVehicleDetailsContainer(claimDetailsData)
            },
            noClaimPaymentsDetails: {
                visible: !this.checkPaymentsHasDetails()
            },
            claimPaymentsDetails: {
                visible: this.checkPaymentsHasDetails()
            },
            noClaimServicesDetails: {
                visible: !this.checkServiceRequestsHasDetails()
            },
            claimServicesDetails: {
                visible: this.checkServiceRequestsHasDetails()
            },
            claimDetailsPage: {
                visible: isClaimDetailsPageVisible
            },
            summaryRightDiv: {
                visible: this.canAccessFinancials()
            },
            partyTableContainer: {
                // visible: ['producer', 'vendor', 'csr'].includes(appConfig.persona)
                // visible:this?.props?.location?.state?.lobName !=="Workers' Compensation"

            },
            claimDetailsTabset: {
                defaultActiveTab: selectedTab
            },
            // vendorTableContainer: {
            //     visible: appConfig.persona === 'policyholder'
            // },
            policyType:{
                value: this.getPolicyTypeData(claimDetailsData)
                //value:claimDetailsData?.claim?.policy?.policyType==='WC7WorkersComp'?"Workers' Compensation":claimDetailsData?.claim?.policy?.policyType
            },
            expirationDate:{
                value:this.getExipirationDate(claimDetailsData.claim.policy.expirationDate, intl)

            },
            claimantName:{
                value:claimDetailsData.claim.claimantName,
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            effectiveDate:{
                value:this.getEffectiveDateFun(claimDetailsData.claim.policy.effectiveDate, intl)
            },
            dateClosed:{
                value:this.getdateClosed(claimDetailsData,intl)
                
            },
            claimType:{
                value: claimDetailsData.claim.claimType
                // value: translator({
                //     id: `typekey.ClaimType.${claimDetailsData.claim.claimType}`,
                //     defaultMessage: claimDetailsData.claim.claimType
                // })
            },
            jurisdiction: {
                value: claimDetailsData.claim.jurisdictionState,//this.getJurisdiction(claimDetailsData.claim)
            },
            claimState:{
                value:claimDetailsData?.claim?.claimStatus,
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"

            },
            reportedToCarrierDate:{
                value:this.getReportDateFun(claimDetailsData.claim.reportedToCarrierDate, intl)//this.getDisplayDate(claimDetailsData.claim.reportedToCarrierDate)
            },
            allowableWage:{
                value:this.getDisplayCurrency(claimDetailsData.claim.allowableMonthyWage),
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            primaryPartOfBody:{
                value:claimDetailsData.claim.primaryBodyPart,
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            natureOfInjury:{
                value:claimDetailsData.claim.natureOfInjury,
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            assignedAdjuster:{
                value: this.getAdjusterName(claimDetailsData.claim, translator),
            },
            adjusterPhone:{
                value:claimDetailsData.claim.adjuster.phoneNumber,
                //visible:this?.props?.location?.state?.lobName ==="Workers' Compensation"
            },
            claimDetailsNewBlock:{
                visible: claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation"
            },
            assignedAdjuster1:{
                value: this.getAdjusterName(claimDetailsData.claim, translator),
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            adjusterPhone1:{
                value:claimDetailsData.claim.adjuster.phoneNumber,
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            claimCity:{
                visible: claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation",
                value: claimDetailsData.claim.addresses[0].city,
            },
            exposuresBlockContainer:{
                visible:claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation",
            },
            claimStateyNew:{
                visible: claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation",
                value: translator({
                    id: `typekey.State.${claimDetailsData.claim.addresses[0].state}`,
                    defaultMessage: `typekey.State.${claimDetailsData.claim.addresses[0].state}`
                })
                // value: claimDetailsData.claim.addresses[0].state,
            },
            claimLoseType:{
                visible: claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation",
                //value: claimDetailsData.claim.lossType,
                value: translator({
                    id: `typekey.LossType.${claimDetailsData.claim.lossType}`,
                    defaultMessage: `typekey.LossType.${claimDetailsData.claim.lossType}`
                })
            },
            claimLossCause:{
                visible:claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation",
                value: claimDetailsData.claim.lossCause !== undefined ? claimDetailsData.claim.lossCauseDisplayName : "-"
            },
            claimDetailLossCause:{
                visible: claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation",
                value: claimDetailsData.claim.detailedLossCauseName
            },
           
            indemnityPaid:{
                value:this.getDisplayCurrency(claimDetailsData.claim.indemnityPaid)   
            },
            medicalPaid:{
                value:this.getDisplayCurrency(claimDetailsData.claim.medicalPaid),
                // visible:this?.props?.location?.state?.lobName ==="Workers' Compensation"
            },
            expensePaid:{
                value:this.getDisplayCurrency(claimDetailsData.claim.expensePaid)
            },
            totalPayments:{
                value:this.getDisplayCurrency(claimDetailsData.claim.totalPayments)
            },
            indemnityReserveRemaining:{
                value:this.getDisplayCurrency(claimDetailsData.claim.indemnityReserveRemaining)
            },
            medicalReserveRemaining:{
                value:this.getDisplayCurrency(claimDetailsData.claim.medicalReserveRemaining),
                // visible:this?.props?.location?.state?.lobName ==="Workers' Compensation"
            },
            claimAssociationsBlockContainer:{
                visible:(claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation")  && claimDetailsData?.claim?.claimAssociations?.length > 0
            },
            riskUnitsVINMakeModel:{
                visible:(claimDetailsData?.claim?.policy?.policyType_Ext ==='Commercial Auto Line 7 ' || claimDetailsData?.claim?.policy?.policyType_Ext ==='Commercial Auto') && claimDetailsData?.claim?.policy?.lobs?.commercialAuto?.vehicles.length >0
            },
            VINMakeModel:{
                value:claimDetailsData?.claim?.policy?.lobs?.commercialAuto?.vehicles.length >0?this.getVINMakeModel(claimDetailsData.claim):<div style={{'font-weight': 'var(--GW-FONT-WEIGHT-BOLD)','fontSize':'1.1rem',
                'font-weight': 'normal',
                'color': '#848484'}}>VIN, Make Model</div>,
                visible:(claimDetailsData?.claim?.policy?.policyType_Ext ==='Commercial Auto Line 7 ' || claimDetailsData?.claim?.policy?.policyType_Ext ==='Commercial Auto') && claimDetailsData?.claim?.policy?.lobs?.commercialAuto?.vehicles.length >0
            },
            adjusterTitle1:{
                className:(claimDetailsData?.claim?.policy?.policyType_Ext ==='Commercial Auto Line 7 ' || claimDetailsData?.claim?.policy?.policyType_Ext ==='Commercial Auto') && claimDetailsData?.claim?.policy?.lobs?.commercialAuto?.vehicles.length ===0?"ClaimDetailsPaddingVIN":"claimDetailsSubTitleRiskUnit"
            },
            totalReserveRemaining:{
                value:this.getDisplayCurrency(claimDetailsData.claim.totalReserveRemaining)
            },
            scheduledPayment:{
                value:this.getDisplayCurrency(claimDetailsData.claim.scheduledPayment)
            },
            indemnityRecoveryRemaining:{
                value:this.getDisplayCurrency(claimDetailsData.claim.indemnityRecoveryRemaining)
            },
            medicalRecoveryRemaining:{
                value:this.getDisplayCurrency(claimDetailsData.claim.medicalRecoveryRemaining),
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            totalRecoveryRemaining:{
                value:this.getDisplayCurrency(claimDetailsData.claim.totalRecoveryRemaining)
            },
            summaryContainer3:{
                visible:claimDetailsData?.claim?.policy?.policyType_Ext === "Workers' Compensation"
            },
            claimDetailsOtherThanWC:{
                visible:claimDetailsData?.claim?.policy?.policyType_Ext !== "Workers' Compensation"
            },
            netIndemnityIncurred:{
                value:this.getDisplayCurrency(claimDetailsData.claim.netIndemnityIncurred)
            },
            netMedicalIncurred:{
                value:this.getDisplayCurrency(claimDetailsData.claim.netMedicalIncurred),
                // visible:this?.props?.location?.state?.lobName ==="Workers' Compensation"
            },
            expenseIncurred:{
                value:this.getDisplayCurrency(claimDetailsData.claim.expenseIncurred)
            },
            netToalIncurred:{
                value:this.getDisplayCurrency(claimDetailsData.claim.netToalIncurred)
            },
            riskAddress:{
                value:claimDetailsData.claim.isUnifiedClaim?_.get(claimDetailsData,'claim.riskUnit'):_.get(claimDetailsData,'claim.riskLocation.displayName')
            },
            addNoteButtonId: {
                visible: false
            },
            uploadDocumentsId: {
                visible: true
            },
            downloadClaimLink: {
                visible: selectedTab ==='summaryTab'?true:false
            },
            loadingStatus: {
                visible: isLoadingSub,
                content: this.renderoadingStatus()
            },
            ...this.generatePaymentDetailsOverrides(intl),
            ...this.generateServiceDetailsOverrides(intl)
        };

        

        const resolvers = {
            resolveComponentMap: {
                cpmimontanaclaimdetails: CPMIMontanaClaimDetails
            },
            resolveCallbackMap: {
                getBackToPreviousState: this.getBackToPreviousState,
                getCell: this.getCell,
                getExposureValue:this.getExposureValue,
                getExposureCoverage:this.getExposureCoverage,
                getStatusValueCell:this.getStatusValueCell,
                getDataCell: this.getDataCell,
                getNotesColumnCell: this.getNotesColumnCell,
                getNotesColumnCellDate:this.getNotesColumnCellDate,
                getLimitType: this.getLimitType,
                getPartyNameLink: this.getPartyNameLink,
                getVendorNameLink: this.getVendorNameLink,
                getLinkExposureAdjuster:this.getLinkExposureAdjuster,
                addNote: this.addNote,
                getRemoveIcon: this.getRemoveIcon,
                getViewandDownload: this.getViewandDownload,
                handleDocumentsUpload: this.handleDocumentsUpload,
                sortString: DatatableUtil.sortString,
                sortNumber: DatatableUtil.sortNumber,
                getDisplayCurrency:this.getDisplayCurrency,
                exportClaimDetail:this.exportClaimDetail,
                getdateClosed:this.getdateClosed,
                getDisplayDate:this.getDisplayDate,
                requestClaimStatusReport:this.requestClaimStatusReport,
                getPrimaryClaimNumbers:this.getPrimaryClaimNumbers,
                getClaimNumbers:this.getClaimNumbers,
                onRowClick: (data) => {
                    _.set(data, 'expanded', !data.expanded);
                },
                tabChangeFn: this.tabChangeFn,
               

            },
            resolveClassNameMap: claimDetailsStyles
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, claimDetailsData, id, path, overrides);
        };
        const claimDetailsPage = (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimDetailsData}
                overrideProps={overrides}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        );
        return <div className={cx(claimDetailsStyles.claimDetails)}>{claimDetailsPage}</div>;
    }
}

export const ClaimDetailsComponent = ClaimDetails;
export default withRouter(withViewModelService(
    withIntl(withAuthenticationContext(withModalContext(withDependencies(['ClaimService', 'ClaimDownloadService'])(ClaimDetails))))
));
